export function getPercentage(correct, total) {
  if (!total) return 0;
  return Math.round((correct / total) * 100);
}

export function buildResultSummary(questions) {
  if (!questions?.length) {
    return { bySubject: [], overall: { correct: 0, total: 0, percentage: 0 } };
  }

  const subjectMap = new Map();

  questions.forEach((question) => {
    const subjectName = question.subjectName || 'Outras';
    if (!subjectMap.has(subjectName)) {
      subjectMap.set(subjectName, { subjectName, correct: 0, total: 0 });
    }
    const entry = subjectMap.get(subjectName);
    entry.total += 1;
    if (question.isCorrect) {
      entry.correct += 1;
    }
  });

  const bySubject = Array.from(subjectMap.values())
    .map((entry) => ({
      ...entry,
      percentage: getPercentage(entry.correct, entry.total),
    }))
    .sort((a, b) => a.subjectName.localeCompare(b.subjectName, 'pt-BR'));

  const correct = questions.filter((q) => q.isCorrect).length;
  const total = questions.length;

  return {
    bySubject,
    overall: {
      correct,
      total,
      percentage: getPercentage(correct, total),
    },
  };
}

export function buildSubjectTopicBreakdown(questions) {
  if (!questions?.length) return [];

  const subjectMap = new Map();

  questions.forEach((question) => {
    const materia = question.subjectName || 'Outras';
    const subjectEntry = subjectMap.get(materia) || { materia, total: 0, acertos: 0, topicos: new Map() };
    subjectEntry.total += 1;
    if (question.isCorrect) subjectEntry.acertos += 1;

    const topicKey = question.topicoId != null ? String(question.topicoId) : 'sem-topico';
    const topicEntry = subjectEntry.topicos.get(topicKey) || {
      topicoId: question.topicoId ?? null,
      topico: question.topico || 'Sem tópico definido',
      total: 0,
      acertos: 0,
    };
    topicEntry.total += 1;
    if (question.isCorrect) topicEntry.acertos += 1;
    subjectEntry.topicos.set(topicKey, topicEntry);

    subjectMap.set(materia, subjectEntry);
  });

  return Array.from(subjectMap.values())
    .map((entry) => ({ ...entry, topicos: Array.from(entry.topicos.values()) }))
    .sort((a, b) => a.materia.localeCompare(b.materia, 'pt-BR'));
}

export function getPerformanceLevel(percentage) {
  if (percentage >= 70) return 'good';
  if (percentage >= 50) return 'medium';
  return 'low';
}
